export default function Wrapper({ className, children, style}) {

 return (
  <div className={className} style={{style}}>
    {children}
  </div>
 )
}